<template>
  <DashboardCard @controlsOpen="
    track(`configurações da tela_banner estático ou banner rotativo_${pageAdvertiser.name}`)">
    <img src="@/assets/images/banners.svg" alt="Banner estático ou banner rotativo"
         slot="icon" class="card-icon">
    <span slot="title">Banner estático ou banner rotativo</span>
    <div slot="controls">
      <div>
        <h4 class="d-flex my-3">
          <img src="@/assets/images/icon_tools.svg" class="card-icon mr-1">
          <p class="control-label text-warning mb-0">Configurar identificador</p>
        </h4>
        <LabelSelector v-model="label"/>
      </div>
    </div>
    <BannerForm :presetLabel="label[0]"
                @labelUpdated="newLabel => updateLabel(newLabel)"
                @showAllRules="$emit('showAllRules')"/>
  </DashboardCard>
</template>

<script>
import { mapGetters } from 'vuex';
import DashboardCard from '@/components/DashboardCard';
import LabelSelector from '@/components/LabelSelector';
import BannerForm from '@/components/BannerForm';

export default {
  name: 'BannerFormCard',
  components: {
    LabelSelector,
    DashboardCard,
    BannerForm,
  },
  data() {
    return {
      label: [],
    };
  },
  label: [],
  methods: {
    updateLabel(label) {
      this.label = [label];
    },
  },
  computed: {
    ...mapGetters([
      'pageAdvertiser',
    ]),
  },
};
</script>

<style lang="scss" scoped>
  .control-label {
    @include text-size-regular();
  }
</style>
